import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import HashiCorpVaultRadarConfigListing from './HashiCorpVaultRadarConfigListing';
import HashiCorpVaultRadarCredentialsForm from './HashiCorpVaultRadarCredentialsForm';

const HashiCorpVaultRadarPullAndPushView = (props) => (
    <GenericPullAndPushToolView 
        {...props}
        PullCredentialForm={HashiCorpVaultRadarCredentialsForm}
        PullConfigListingView={HashiCorpVaultRadarConfigListing}
     />
);

export default HashiCorpVaultRadarPullAndPushView;
